import RecreationGovClient from "../externalclients/RecreationGovClient";

//Retrieves site definitions from R1S
export default class SiteService {
  getSiteById(id) {
    let allSites = this.getAllSites();
    return allSites.then(data => {
      let result = data.facilities.find(n => n.id == id);
      return result;
    });
  }

  getAllSites() {
    let client = new RecreationGovClient();
    return client.getSites();
  }
}
